import {ComponentConfig, Config, ItemConfig, ItemConfigType} from 'golden-layout';
import {Tractor} from 'shared';

export const INITIAL_LAYOUT: Config = {
  settings: {
    hasHeaders: true,
    showPopoutIcon: false,
    showMaximiseIcon: false,
    reorderEnabled: false,
  },
  content: [{
    id: 'main',
    type: 'row',
    content: [{
      id: 'main-stack',
      type: 'stack',
      content: [/*{
        id: 'dashboard',
        type: 'component',
        componentName: 'dashboard',
        title: 'Dashboard',
        isClosable: false,
      },*/
        {
          id: 'map-content',
          type: 'row',
          title: 'La carte',
          isClosable: false,
          content: [
            {
              id: 'map-side-stack',
              type: 'stack',
              width: 20,
              content: [{
                id: 'map-tractors',
                type: 'component',
                componentName: 'map-tractors',
                // @ts-ignore
                header: {
                  // show: false,
                  popout: false,
                  close: false,
                  maximize: false,
                  minimize: false,
                }
              }, {
                id: 'map-fields',
                type: 'component',
                componentName: 'map-fields',
                // @ts-ignore
                header: {
                  // show: false,
                  popout: false,
                  close: false,
                  maximize: false,
                  minimize: false,
                }
              }, {
                id: 'map-poi',
                type: 'component',
                componentName: 'map-poi',
                // @ts-ignore
                header: {
                  // show: false,
                  popout: false,
                  close: false,
                  maximize: false,
                  minimize: false,
                }
              }]
            },
            {
              id: 'map',
              type: 'component',
              componentName: 'map',
              // @ts-ignore
              header: {
                show: false,
                popout: false,
              }
              /*header : {
                  show: false | 'top' | 'left' | 'right' | 'bottom'
                  maximize : false | 'custom label',
                  minimize :  'custom label',
                  popout :  false | 'custom label',
                  close: 'custom label',
              }*/
            }]
        },
      ]
    }]
  }
  ],
  dimensions: {
    borderWidth: 4,
    headerHeight: 30,
  }
};
